module.exports = __webpack_public_path__ + "img/business-and-finance.08219bd5.svg";